
import { useEffect, useRef } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'
import { ErrorState } from './ErrorState'
import { createLogger } from '@/lib/logger';

const logger = createLogger('components/shared/FeatureErrorBoundary');

export interface FeatureErrorBoundaryProps {
  featureName: string
}

export function FeatureErrorBoundary({ featureName }: FeatureErrorBoundaryProps) {
  const error = useRouteError()
  const navigate = useNavigate()
  const hasLogged = useRef(false)
useEffect(() => {
    if (hasLogged.current) return
    logger.error(`${featureName} route error`, error)
    hasLogged.current = true
  }, [error, featureName, logger])

  const description = (() => {
    if (isRouteErrorResponse(error)) {
      return error.statusText || `Request failed with status ${error.status}`
    }
    if (error instanceof Error) {
      return error.message
    }
    return 'Please try again or contact support if the issue persists.'
  })()

  return (
    <ErrorState
      title={`${featureName} is unavailable`}
      description={description}
      onRetry={() => navigate(0)}
      onBack={() => navigate(-1)}
      fullScreen
    />
  )
}
